import React from 'react';
import styles from './button.module.scss';
// import { IButton } from '../../atoms.interfaces';
import type { IButton } from '../../atoms.interfaces';
//comment to test with normal commit 

export const Button: React.FC<IButton> = ({
  className,
  variant = 'primary',
  size = 'small',
  color = 'primary',
  label,
  icon,
  disabled,
  type = 'button',
  ...props
}) => {
  const typographyClass = size === 'micro' || size === 'small' ? 'detail' : 'heading4';

  // FLEXO-6133 #6e: callers swap `label` for a Lottie loader mid-submit,
  // which left the button with no accessible name. Remember the last text
  // label and expose it as aria-label while the label is not a string.
  // An explicit aria-label passed via props still wins (spread below).
  const lastTextLabel = React.useRef<string | undefined>(undefined);
  if (typeof label === 'string' && label.trim() !== '') {
    lastTextLabel.current = label;
  }

  return (
    <button
      type={type}
      className={`${styles.Button} ${styles[`Button--${variant}`]} ${
        styles[`Button--${size}`]
      } ${styles[`Button--${variant}--${color}`]} ${className} ${typographyClass}`}
      aria-label={typeof label === 'string' ? undefined : lastTextLabel.current}
      {...props}
      disabled={disabled}
    >
      <div>
        {icon && <span className={styles.Button__Icon}>{icon}</span>}
        <span>{label}</span>
      </div>
    </button>
  );
};

export default Button;
